export default {
  PROFILEOBJ: "PROFILEOBJ",
  HISTORYOBJ:"HISTORYOBJ",
  AUTHORIZATION: "AUTHORIZATION",
  SUBSCRIPTION: "SUBSCRIPTION",
};
